import { useEffect } from "react";
import { ProjetoDimensionadoHibrido } from "src/components/projetos/dimensionados_hibrido";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Projeto dimensionado híbrido";

export const ProjetosHibridoDimensionadosPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <ProjetoDimensionadoHibrido />
        </div>
      </div>
    </div>
  );
};
